
const roles = {
    Admin: 1,
    Technician: 2,
    Subcontractor: 3,
    CustomerManager: 4,
    Partner: 5,
};
export default roles;